import { ListGroup, Row, Col } from "react-bootstrap";

export default function OrderSummary(props) {
  // displays a summary of the order details, including the quantity of items, item subtotal, shipping and handling cost, total before tax, tax amount, and the grand total

  if(!props.data){
    return null
  }
  return (
    <ListGroup>
      <ListGroup.Item>
        <h3>Summary ({props?.data?.quantity} item(s))</h3>
      </ListGroup.Item>
      <ListGroup.Item>
        <Row>
          <Col xs={8}>
            <span>Item(s) Subtotal:</span>
          </Col>
          <Col xs={4}>
            <span>{props?.data?.cartSubtotal ? `${props?.data?.cartSubtotal.toLocaleString("en-CA", {
                    style: "currency",
                    currency: "CAD",
                  })}` : "TBD"}</span>
          </Col>
        </Row>
        <Row>
          <Col xs={8}>
            <span>Shipping & Handling:</span>
          </Col>
          <Col xs={4}>
          <span>{props?.data?.shippingHandling > 0 ? `${props?.data?.shippingHandling.toLocaleString("en-CA", {
                    style: "currency",
                    currency: "CAD",
                  })}` : (props?.data?.shippingHandling === 0 ? "Free":"TBD")}</span>
          </Col>
        </Row>
        <Row>
          <Col xs={8}>
            <span>Total before tax:</span>
          </Col>
          <Col xs={4}>
          <span>{props?.data?.totalBeforeTax ? `${props?.data?.totalBeforeTax.toLocaleString("en-CA", {
                    style: "currency",
                    currency: "CAD",
                  })}` : "TBD"}</span>
          </Col>
        </Row>
        <Row>
          <Col xs={8}>
            <span>Tax: {props?.data?.tax?.taxType}</span>
          </Col>
          <Col xs={4}>
          <span>{props?.data?.tax?.taxAmount >=0 ? `${props.data.tax.taxAmount.toLocaleString("en-CA", {
                    style: "currency",
                    currency: "CAD",
                  })}` : "TBD"}</span>
          </Col>
        </Row>
        <Row className="mt-3 border-top">
          <Col xs={8}>
            <span className="fw-bold" >Grand Total:</span>
          </Col>
          <Col xs={4}>
            <span className="fw-bold">{props?.data?.grandTotal ? `${props?.data?.grandTotal.toLocaleString("en-CA", {
                    style: "currency",
                    currency: "CAD",
                  })}` : "error"}</span>
          </Col>
        </Row>
      </ListGroup.Item>
    </ListGroup>
  );
}
